/**
 * PROJECT MANAGER COMPONENT
 * Project management and organization
 */

import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, Plus, Code, Brain } from 'lucide-react';

export function ProjectManager() {
  const projects = [];

  return (
    <div className="h-full p-6 bg-gradient-to-b from-slate-900/50 to-slate-800/50 overflow-y-auto">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-white mb-2">Project Manager</h1>
            <p className="text-slate-400">AI-enhanced project organization and insights</p>
          </div>
          <button 
            onClick={() => {
              const projectName = prompt('Enter project name:');
              if (projectName) {
                alert(`Project "${projectName}" created! (This would integrate with real project management)`);
              }
            }}
            className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all"
          >
            <Plus className="w-4 h-4" />
            <span>New Project</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.length === 0 ? (
            <div className="col-span-full text-center py-12">
              <div className="text-slate-400 mb-4">No projects yet</div>
              <p className="text-slate-500 text-sm">Create your first project to get started with AI-powered development</p>
            </div>
          ) : projects.map((project, index) => (
            <motion.div
              key={project.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white/10 border border-white/20 rounded-lg p-6 backdrop-blur-sm hover:bg-white/15 transition-all cursor-pointer"
            >
              <div className="flex items-center space-x-3 mb-4">
                <FolderOpen className="w-8 h-8 text-blue-400" />
                <div>
                  <h3 className="font-semibold text-white">{project.name}</h3>
                  <p className="text-sm text-slate-400">{project.language}</p>
                </div>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-300">Files</span>
                  <span className="text-white">{project.files}</span>
                </div>
                
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-300 flex items-center space-x-1">
                    <Brain className="w-3 h-3" />
                    <span>AI Score</span>
                  </span>
                  <span className="text-green-400 font-medium">{project.aiScore}%</span>
                </div>
                
                <div className="w-full bg-slate-700 rounded-full h-2">
                  <div 
                    className="bg-gradient-to-r from-green-500 to-teal-600 h-2 rounded-full"
                    style={{ width: `${project.aiScore}%` }}
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}